module.exports = __webpack_public_path__ + "static/reqCredit-6d238411d8001187c7f6d1c59faf7b6a.svg";